import config from 'constants/config'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import React from 'react'
import styled from 'styled-components'
import LayoutContainer from './LayoutContainer'
import WithSideBar from './WithSideBar'

const Container = styled(LayoutContainer)`
  padding-block: ${rem(24)};
`

function StaticContentPageContainer(props: PropsWithChildren) {
  const { children } = props

  return <Container>
    {config.legalPagesSideBar && <WithSideBar>
      {children}
    </WithSideBar>}
    {!config.legalPagesSideBar && <>{children}</>}
  </Container>
}

export default StaticContentPageContainer
